var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "dialog",
        height: "auto",
        classes: ["v--modal", "vue-dialog", this.params.class],
        width: _vm.width,
        "pivot-y": 0.3,
        adaptive: true,
        clickToClose: _vm.clickToClose,
        transition: _vm.transition
      },
      on: {
        "before-open": _vm.beforeOpened,
        "before-close": _vm.beforeClosed,
        opened: function($event) {
          return _vm.$emit("opened", $event)
        },
        closed: function($event) {
          return _vm.$emit("closed", $event)
        }
      }
    },
    [
      _c("div", { staticClass: "dialog-content" }, [
        _vm.params.title
          ? _c("div", {
              staticClass: "dialog-c-title",
              domProps: { innerHTML: _vm._s(_vm.params.title || "") }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "dialog-c-text",
          domProps: { innerHTML: _vm._s(_vm.params.text || "") }
        })
      ]),
      _vm._v(" "),
      _vm.buttons
        ? _c(
            "div",
            { staticClass: "vue-dialog-buttons" },
            _vm._l(_vm.buttons, function(button, i) {
              return _c(
                "button",
                {
                  key: i,
                  class: button.class || "vue-dialog-button",
                  style: _vm.buttonStyle,
                  attrs: { type: "button" },
                  domProps: { innerHTML: _vm._s(button.title) },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.click(i, $event)
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(button.title) + "\n    ")]
              )
            }),
            0
          )
        : _c("div", { staticClass: "vue-dialog-buttons-none" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }